import { atom, useAtom } from 'jotai';

interface Payload {
  callback?: () => void;
}

export const deleteNotesWarningModalPayload = atom<Payload | undefined>(
  undefined,
);

export function useDeleteNotesWarningModal() {
  const [modalPayload, setModalPayload] = useAtom(
    deleteNotesWarningModalPayload,
  );
  return {
    isOpen: !!modalPayload,
    open: (v: Payload) => setModalPayload(v),
    closeModal: () => setModalPayload(undefined),
    payload: modalPayload,
  };
}
